import { isFilledArray } from 'magic/checkValuesExist';

/**
 * Проверяет наличие прав у юзера
 *
 * @param {boolean} some - флаг, который позволяет проверять наличие хотя бы одного обязательного права либо в глобальных правах, либо у организаций юзера (но это неточно)
 * @param {boolean} oneOf - флаг, который позволяет проверять наличие хотя бы одного обязательного права в организациях юзера, иначе сразу всех обязательных прав в организациях
 * @param {string | array} permissionKey - указатель, какие права юзера проверять: глобально или среди организаций
 * @param {object} userPermissions - объект с правами юзера
 * @param {array} requiredPermissions - массив обязательных прав для отображения компонента
 *
 * @returns {boolean} - имеет права или нет
 */
export const checkPermissions = (some, oneOf, permissionKey, userPermissions, requiredPermissions) => {
  const userProfilePermissionList = userPermissions?.userProfilePermissionList ?? [];
  const userProfilePermissionOrgChilds = userPermissions?.userProfilePermissionOrgChilds ?? [];

  if (!isFilledArray(requiredPermissions)) {
    return true;
  }

  if (permissionKey !== 'global' && !isFilledArray(permissionKey) && !some) {
    return false;
  }

  const checkPermissionGlobally = (permission) => {
    const found = userProfilePermissionList.find((item) => {
      const hasPermission = item.permission?.sysName === permission;
      return hasPermission;
    });
    return !!found;
  };

  const checkPermissionGloballyWithoutOrg = (permission) => {
    const found = userProfilePermissionList.find((item) => {
      const hasPermission = item.permission?.sysName === permission && item.organizationId == null;
      return hasPermission;
    });
    return !!found;
  };

  const checkPermissionInOrgs = (permission) => {
    const found = userProfilePermissionList.find((item) => {
      const hasPermission = item.permission?.sysName === permission;
      if (!hasPermission) return false;

      const inOrganization = permissionKey.includes(item.organizationId);
      if (inOrganization) return true;

      const foundOrgChilds = userProfilePermissionOrgChilds.find((org) => org.organizationId === item.organizationId)?.childs ?? [];
      const inChilds = permissionKey.some((pk) => foundOrgChilds.includes(pk));

      return inChilds;
    });

    return !!found;
  };

  if (permissionKey === 'global') {
    return oneOf ? requiredPermissions.some(checkPermissionGlobally) : requiredPermissions.every(checkPermissionGlobally);
  }

  if (some) {
    const someGloballyWithoutOrg = requiredPermissions.some(checkPermissionGloballyWithoutOrg);
    if (someGloballyWithoutOrg) return true;

    const someInOrgs = isFilledArray(permissionKey) ? requiredPermissions.some(checkPermissionInOrgs) : false;
    return someInOrgs;
  }

  return oneOf ? requiredPermissions.some(checkPermissionInOrgs) : requiredPermissions.every(checkPermissionInOrgs);
};
